import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import yup from "../../../../utils/yup";
import { CeTextInput } from "../../../generic/components/form-fields/ce-text-field";

import type { UUID } from "../../../../utils/uuid";
import type { FC } from "react";

export const copyMomentSchema = yup.object({
  name: yup.string().required("Enter the name of the new Communication").label("Name"),
});

export interface CopyDialogProps {
  open: boolean;
  id: UUID;
  title: string | null;
  onClose: () => void;
}

export const CopyDialog: FC<CopyDialogProps> = ({ id, open, title, onClose }) => {
  const navigate = useNavigate();

  const onSubmit = useCallback(
    (data: { name: string }) => {
      void navigate(`/moments/copy/${id}?new_title=${encodeURIComponent(data.name)}`);
    },
    [id, navigate],
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Copy Communication</DialogTitle>
      <CopyMomentDialogForm title={title} onSubmit={onSubmit} onClose={onClose} />
    </Dialog>
  );
};

export const CopyMomentDialogForm: FC<{
  title: string | null;
  onSubmit: (data: { name: string }) => void;
  onClose: () => void;
}> = ({ title, onSubmit, onClose }) => {
  const methods = useForm({
    defaultValues: { name: `Copy of ${title ?? ""}` },
    resolver: yupResolver(copyMomentSchema),
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={(e) => void methods.handleSubmit(onSubmit)(e)}>
        <DialogContent>
          <CeTextInput
            analyticsCategory="moment"
            name="name"
            margin="dense"
            label="Name"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button data-analytics-id="moment-copy-dialog-cancel" color="error" onClick={onClose}>
            Cancel
          </Button>
          <Button
            data-analytics-id="moment-copy-dialog-confirm"
            color="primary"
            variant="contained"
            type="submit"
          >
            Make a Copy
          </Button>
        </DialogActions>
      </form>
    </FormProvider>
  );
};
